var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.875C6 22.875 1.125 18 1.125 12C1.125 6 6 1.125 12 1.125C18 1.125 22.875 6 22.875 12C22.875 18 18 22.875 12 22.875ZM12 2.25C6.61875 2.25 2.25 6.61875 2.25 12C2.25 17.3813 6.61875 21.75 12 21.75C17.3813 21.75 21.75 17.3813 21.75 12C21.75 6.61875 17.3813 2.25 12 2.25Z",
    fill: "#495464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.875C11.6812 16.875 11.4375 16.6313 11.4375 16.3125V11.4375C11.4375 11.1187 11.6812 10.875 12 10.875C12.3188 10.875 12.5625 11.1187 12.5625 11.4375V16.3125C12.5625 16.6313 12.3188 16.875 12 16.875Z",
    fill: "#495464"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.1875C11.6812 9.1875 11.4375 8.94375 11.4375 8.625V7.6875C11.4375 7.36875 11.6812 7.125 12 7.125C12.3188 7.125 12.5625 7.36875 12.5625 7.6875V8.625C12.5625 8.94375 12.3188 9.1875 12 9.1875Z",
    fill: "#495464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.8f334d137f10d88c00822d1880d04e37.svg";
export { ForwardRef as ReactComponent };